// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3a_rz","calendarButtons":"ClockData_calendarButtons__34QWN"};